import React, { useState } from "react";
import { Modal, Spinner, Text } from "@shopify/polaris";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
const CourseLoader = (props) => {
  console.log("props.progress=", props.progress);
  return (
    <div className="loadingScreen">
      <div className="loadingCourse">
        <Spinner />
        <p style={{ color: "white", fontSize: "1rem" }}>
          Please wait a few seconds...
        </p>
      </div>
    </div>
  );
};

export default CourseLoader;
